import { TransportVoucherData } from "@/types/navigation";

// Codec + signature du jeton de partage « lecture seule » du bon de transport.
// SÉCURITÉ : l'algorithme (sel, base64url, hash) est volontairement conservé à
// l'identique — toute modification invaliderait les liens VTC déjà partagés.

const SHARED_MODE_SALT = ["ks", "rent", "vtc", "share", "mode"].join("-");

export const toBase64Url = (value: string): string => {
  if (typeof window === "undefined") return "";
  const base64 = window.btoa(unescape(encodeURIComponent(value)));
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
};

export const fromBase64Url = (value: string): string => {
  if (typeof window === "undefined") return "";
  const base64 = value
    .replace(/-/g, "+")
    .replace(/_/g, "/")
    .padEnd(Math.ceil(value.length / 4) * 4, "=");
  return decodeURIComponent(escape(window.atob(base64)));
};

export const createPayloadSignature = (encodedPayload: string): string => {
  const source = `${encodedPayload}:${SHARED_MODE_SALT}`;
  let hash = 0;
  for (let i = 0; i < source.length; i += 1) {
    hash = (hash << 5) - hash + source.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash).toString(36);
};

export const buildSharedToken = (voucher: TransportVoucherData): string => {
  const payload = toBase64Url(JSON.stringify(voucher));
  const sig = createPayloadSignature(payload);
  return new URLSearchParams({ d: payload, m: sig }).toString();
};

export const readSharedToken = (
  searchParams: URLSearchParams,
): TransportVoucherData | null => {
  const payload = searchParams.get("d");
  const sig = searchParams.get("m");
  if (!payload || !sig) return null;
  if (createPayloadSignature(payload) !== sig) return null;
  try {
    return JSON.parse(fromBase64Url(payload)) as TransportVoucherData;
  } catch {
    return null;
  }
};
